<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="row != null">
      <OperationDialogTitle v-bind="row" @close="dismiss" />

      <v-card-text class="pa-3">
        <div class="d-flex flex-wrap items-start">
          <OCapCont class="w-full pa-3" label="Veículo">
            <ReadonlyVehicle
              v-if="activeInstall != null && activeInstall.vehicle != null"
              :vehicle="activeInstall.vehicle"
              :history="activeInstall"
            />
          </OCapCont>

          <ODateTimeInput2
            :readonly="readonly"
            class="w-full pa-3"
            v-model="row.timestamp"
            label="Data/hora do registro"
            :clearable="false"
          />

          <OAlert warning class="w-full ma-3" v-if="helpText != null">
            <div class="pre-line" v-html="helpText" />
          </OAlert>

          <OAlert class="w-full ma-3" info v-if="lastChecklist != null">
            <span>
              Último checklist:
              <b>{{ lastChecklist.at | moment('DD/MMM/YYYY') }}</b>
              por
              <code>{{ lastChecklist.by }}</code>
            </span>
            <div class="pre-line" v-html="lastChecklist.comments" />
          </OAlert>

          <RowDates class="ma-3" :value="row" />
        </div>
      </v-card-text>

      <ODialogButtons
        class="pa-6"
        @cancel="dismiss"
        txtApply="Marcar como verificado"
        @apply="apply"
      />
    </v-card>
  </ODialog>
</template>

<script>
import TheUser from 'oderon-vue/auth/TheUser'
import RowDates from './RowDates.vue'
import OperationDialogTitle from './OperationDialogTitle.vue'
import { ClientHistory, SysConfig, InstalledBase } from '@/models'
import ReadonlyVehicle from './ReadonlyVehicle.vue'
import { postOrPatch, findActiveInstall, canEdit } from './operation-utils'

export default {
  components: { ReadonlyVehicle, RowDates, OperationDialogTitle },
  data() {
    return {
      ...this.reset(),
      TheUser,
      helpText: `Lembre-se de verificar:
1. Se o módulo está transmitindo
2. Se os trechos estão vindo com motorista
3. ...`
    }
  },
  computed: {
    readonly() {
      return this.row && this.row.id && !canEdit(this.TheUser)
    }
  },
  methods: {
    reset() {
      return {
        row: null,
        activeInstall: null,
        lastChecklist: null
      }
    },
    open({ clientId, historyId }) {
      Object.assign(this, this.reset())

      this.$refs.dialog.$loading(() => this.fetchData(clientId, historyId))

      return this.$refs.dialog.$open()
    },

    async fetchData(clientId, historyId) {
      let cfgs = await SysConfig.findAll()
      let str = cfgs.clientChecklistHelpText
      if (str != null) this.helpText = str.replaceAll('\\n', '\n')

      let pair = await InstalledBase.findPrimaryByCid(clientId)
      if (pair != null) {
        this.lastChecklist = pair.client.lastChecklist
      }

      if (historyId == null) {
        // usamos activeInstall porque não faz sentido associar
        // ticket pra módulos que não estão instalados.
        let activeInstall = await findActiveInstall(clientId)
        this.row = {
          timestamp: new Date(),
          clientId: clientId,
          type: 'checklist',
          vehicleId: activeInstall && activeInstall.vehicleId
        }

        // Usado apenas para mostrar no ReadonlyVehicle
        this.activeInstall = activeInstall
      } else {
        this.row = await ClientHistory.findById(historyId)
      }
    },

    apply() {
      this.$refs.dialog.$loading(async () => {
        await postOrPatch('/clients/:cid/checklist', this.row)
        this.$snack('Registro salvo com sucesso')
        this.$refs.dialog.$apply('RELOAD')
      })
    },

    dismiss() {
      return this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
